/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './NavigationView.types.tsx';
import { expandSectionForSelectedView } from './expandSectionForSelectedView.tsx';
import { withRefreshBlocker } from './withRefreshBlocker.tsx';
import { transformRemoteView, updateContainerState } from './updateContainerState.tsx';

export const loadViews = ({ tryPreload }: { tryPreload?: boolean } = {}): Action<State, Props> =>
	withRefreshBlocker(
		async (
			{ setState, getState, dispatch },
			{ navigationRemote, cloudId, containerId, onFailure, onSuccess },
		) => {
			if (
				!cloudId ||
				!containerId ||
				!navigationRemote ||
				getState().containers[containerId]?.isLoading ||
				getState().containers[containerId]?.initialized
			) {
				if (!tryPreload && getState().containers[containerId]?.isLoading) {
					// it means preload is in progress and we need to try again if case of preload failure
					setState(
						updateContainerState(getState(), containerId, {
							tryAgainAfterPreloadFailure: true,
						}),
					);
				}
				return;
			}

			setState(
				updateContainerState(getState(), containerId, {
					isLoading: true,
					initialized: true,
					loadingError: null,
					tryAgainAfterPreloadFailure: false,
					views: [],
				}),
			);

			try {
				const views = await navigationRemote.fetch(containerId);
				setState(
					updateContainerState(getState(), containerId, {
						isLoading: false,
						initialized: true,
						loadingError: null,
						views: views?.map(transformRemoteView),
					}),
				);
				dispatch(expandSectionForSelectedView());
				onSuccess?.('loadViews');
				// oxlint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				if (!tryPreload) {
					setState(
						updateContainerState(getState(), containerId, {
							isLoading: false,
							initialized: true,
							loadingError: error,
							views: [],
						}),
					);

					onFailure?.(error, 'loadViews');
				} else {
					setState(
						updateContainerState(getState(), containerId, {
							isLoading: false,
							initialized: false,
							loadingError: null,
							views: [],
						}),
					);
				}

				// if preload failed on non onboarded project, we need to try again after project is onboarded
				if (tryPreload && getState().containers[containerId]?.tryAgainAfterPreloadFailure) {
					dispatch(loadViews());
				}
			}
		},
	);
